import * as _ from 'lodash';

export function getActivityChecked(value) {
    return _.map(_.filter(_.toPairs(value), ([key, checked]) => checked), ([key]) => key);
}


// WEBPACK FOOTER //
// ./src/utils/getActivityChecked.js